import { useEffect, useRef, useState } from "react";
import { Hero } from "@/components/landing/Hero";
import { SpeakerCredentials } from "@/components/landing/SpeakerCredentials";
import { StudentCases } from "@/components/landing/StudentCases";
import { CommunityProof } from "@/components/landing/CommunityProof";
import { CommunityMembers } from "@/components/landing/CommunityMembers";
import { PainPoints } from "@/components/landing/PainPoints";
import { Takeaways } from "@/components/landing/Takeaways";
import { AIDemo } from "@/components/landing/AIDemo";
import { Why2026 } from "@/components/landing/Why2026";
import { FAQ } from "@/components/landing/FAQ";
import { RegistrationForm } from "@/components/landing/RegistrationForm";
import { StickyCta } from "@/components/landing/StickyCta";
import { Footer } from "@/components/landing/Footer";
import { publicApi } from "@/lib/api";

export default function LandingPage() {
  const [settings, setSettings] = useState(null);
  const [dropdowns, setDropdowns] = useState(null);
  const formRef = useRef(null);

  const loadSettings = async () => {
    try {
      const s = await publicApi.getSettings();
      setSettings(s);
    } catch (e) {
      console.error("Failed to load settings", e);
    }
  };

  const loadDropdowns = async () => {
    try {
      const d = await publicApi.getDropdowns();
      setDropdowns(d);
    } catch (e) {
      console.error("Failed to load dropdowns", e);
    }
  };

  useEffect(() => {
    loadSettings();
    loadDropdowns();
  }, []);

  const scrollToForm = () => {
    if (formRef.current) {
      formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      setTimeout(() => {
        const nameEl = document.querySelector('[data-testid="webinar-registration-name-input"]');
        if (nameEl) nameEl.focus({ preventScroll: true });
      }, 700);
    }
  };

  const handleRegistered = () => {
    // refresh seats_remaining after a successful registration
    loadSettings();
  };

  return (
    <main className="min-h-screen">
      <Hero settings={settings} onCtaClick={scrollToForm} />
      <SpeakerCredentials onCtaClick={scrollToForm} />
      <CommunityMembers onCtaClick={scrollToForm} />
      <CommunityProof onCtaClick={scrollToForm} />
      <StudentCases onCtaClick={scrollToForm} />
      <PainPoints />
      <Takeaways />
      <AIDemo onCtaClick={scrollToForm} />
      <Why2026 />
      <FAQ onCtaClick={scrollToForm} />
      <RegistrationForm
        settings={settings}
        dropdowns={dropdowns}
        onRegistered={handleRegistered}
        formRef={formRef}
      />
      <Footer />
      <StickyCta onCtaClick={scrollToForm} seatsRemaining={settings?.seats_remaining} settings={settings} />
    </main>
  );
}
